// This file was automatically generated from appchart.refpanel.hccScoreDetails.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.refpanel.hccScoreDetails');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.hccScoreDetails.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8DialogContainer el8StandardFontSize m5 padt0"><div class="tabbed-nav el8TabHomeSection mb10"></div>');
  el8.template.appchart.refpanel.hccScoreDetails._hccScoreTab({tabClass: 'hcc-detail-community', scoreName: 'communityNondualAged', data: opt_data.data}, output);
  el8.template.appchart.refpanel.hccScoreDetails._hccScoreTab({tabClass: 'hcc-detail-institutional', scoreName: 'institutional', data: opt_data.data}, output);
  output.append('<div class="m5 mt20">Elation’s Risk Assessment score provides a snapshot into the severity of a patient’s health risk. A lower score indicates a less severe status, where 1.0 is the average score for Medicare beneficiaries based on the current CMS HCC Risk Adjustment Model.</div><div class="m5"><span class="el8Bold">&midast;</span> ', soy.$$escapeHtml(opt_data.data.totalsDescription), '</div><div class="m5 mt20 el8AlignRight"><a href="https://help.elationhealth.com/s/article/how-to-use-elations-risk-assessment-feature" target="_blank" rel="noopener">Learn more about Risk Assessment scoring</a></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.hccScoreDetails._hccScoreTab = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class=', soy.$$escapeHtml(opt_data.tabClass), '>');
  el8.template.appchart.refpanel.hccScoreDetails._hccScoreRow({scoreName: opt_data.scoreName, columns: opt_data.data.columns, row: opt_data.data.headerRow}, output);
  output.append('<hr class="mv3" />');
  var iList5223 = opt_data.data.scoredItems;
  var iListLen5223 = iList5223.length;
  for (var iIndex5223 = 0; iIndex5223 < iListLen5223; iIndex5223++) {
    var iData5223 = iList5223[iIndex5223];
    el8.template.appchart.refpanel.hccScoreDetails._hccScoreRow({scoreName: opt_data.scoreName, columns: opt_data.data.columns, row: iData5223}, output);
  }
  output.append('<hr class="mv3" />');
  var iList5230 = opt_data.data.summaryRows;
  var iListLen5230 = iList5230.length;
  for (var iIndex5230 = 0; iIndex5230 < iListLen5230; iIndex5230++) {
    var iData5230 = iList5230[iIndex5230];
    el8.template.appchart.refpanel.hccScoreDetails._hccScoreRow({scoreName: opt_data.scoreName, columns: opt_data.data.columns, row: iData5230}, output);
  }
  output.append('<hr class="mt3" /><div class="el8InlineBlock el8ExtraLargeFontSize mt2 w80 el8Bold">Total&midast;</div><div class="el8InlineBlock el8ExtraLargeFontSize el8AlignRight mt2 w20 el8Bold el8HccScore">', soy.$$escapeHtml(opt_data.data.totals[opt_data.scoreName]), '</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.hccScoreDetails._hccScoreRow = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8InlineBlock mt2 ', (opt_data.columns.length == 1) ? 'w85' : 'w55', (opt_data.row.bold) ? ' el8Bold' : '', (opt_data.row.bold && ! opt_data.row.isScores) ? ' el8LargeFontSize' : '', '">', soy.$$escapeHtml(opt_data.row.description), '</div>');
  var colList5255 = opt_data.columns;
  var colListLen5255 = colList5255.length;
  for (var colIndex5255 = 0; colIndex5255 < colListLen5255; colIndex5255++) {
    var colData5255 = colList5255[colIndex5255];
    output.append('<div class="el8InlineBlock el8AlignRight mt2 w15', (opt_data.row.bold && ! opt_data.row.isScores) ? ' el8Bold el8LargeFontSize' : '', (opt_data.row.isScores) ? ' el8HccScore' : '', ' col-for-', soy.$$escapeHtml(colData5255), '">', (opt_data.row.scoresByColumn[colData5255]) ? soy.$$escapeHtml(opt_data.row.scoresByColumn[colData5255][opt_data.scoreName]) : '', '</div>');
  }
  if (!opt_sb) return output.toString();
};
